export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8967.d05dabe5.jpg";